<button type="button" (click)="handleClick($event)" [disabled]="disabled">
    <ng-content></ng-content>
</button>